import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MemberSubService {

  constructor(
    private requestService: RequestService
  ) { }

  GetSubMemberData(CompanyID:string,UserID:string){
      var param = {
        "CompanyID":CompanyID,
        "UserID": UserID
      };
      return this.requestService.Post<string>(environment.baseUrl + '/SubProjectMember/GetMemberSubData',param);
  }
  SaveSign(value: any){
      return this.requestService.Post<string>(environment.baseUrl + '/SubProjectMember/SaveSign',value);
  }
}
